<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Solicitação LGPD</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="sistema">
                      <span class="required">*</span> Sistema:
                    </label>
                    <v-select v-model="lgpd.project_id" :options="projects" :reduce="(project) => project.id"
                      :label="'name'" />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="Name">
                      <span class="required">*</span> Nome:
                    </label>
                    <input type="text" id="Name" class="form-control" v-model="lgpd.name" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="Email">
                      <span class="required">*</span> E-mail:
                    </label>
                    <input type="email" id="Email" class="form-control" v-model="lgpd.email" />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="Number">
                      <span class="required">*</span> Telefone:
                    </label>
                    <input type="tel" id="Number" class="form-control" v-model="lgpd.number"
                      v-mask="'(99)99999-9999'" />
                  </div>

                  <div class="form-group col-md-6">
                    <label for="status">
                      <span class="required">*</span> Status:
                    </label>
                    <select v-model="lgpd.status" class="form-control" id="status">
                      <option :value="0">Aguardando atendimento</option>
                      <option :value="1">Em atendimento</option>
                      <option :value="2">Finalizado</option>
                    </select>
                  </div>


                </div>
                <div class="form-group">
                  <label for="description">
                    <span class="required">*</span> Descrição:
                  </label>
                  <textarea id="description" class="form-control" v-model="lgpd.description" rows="4"></textarea>
                </div>

                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>

                <div class="block text-right mb-1">
                  <router-link to="/lgpds" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Enviar
                    <i class="fa fa-paper-plane"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      lgpd: {
        project_id: "",
        name: "",
        email: "",
        number: "",
        description: "",
        status: 0,
      },
      projects: [],
      statusOptions: [
        { id: 0, text: "Aguardando atendimento" },
        { id: 1, text: "Em atendimento" },
        { id: 2, text: "Finalizado" },
      ],

    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "lgpds";

      if (self.lgpd.id) {
        api += "/" + self.lgpd.id;
        self.lgpd._method = "PUT";
      }

      axios
        .post(api, self.lgpd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/lgpds");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getLgpds: function (id) {
      const self = this;
      const api = self.$store.state.api + "lgpds/" + id;

      axios
        .get(api)
        .then((response) => {
          const data = response.data.data[0];
          // Garante que project_id seja só o ID (e não objeto)
          self.lgpd = {
            ...data,
            project_id: data.project_id?.id || data.project_id,
            status: Number(data.status),
          };
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getProjects: function () {
      const self = this;
      const api = self.$store.state.api + "projects?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.projects = response.data.data || response.data.projects;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getProjects(); // <-- Adicionado
    let id = self.$route.params.id;

    if (id) {
      self.getLgpds(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

::v-deep .v-select {
  font-size: 0.875rem;
}

::v-deep .vs__dropdown-toggle {
  border-radius: 4px;
  border: 1px solid #6c757d;
  min-height: 38px;
  padding: 6px 12px;
  background-color: #1f2638;
  /* Ajuste conforme seu tema */
  color: #fff;
}
</style>
